@use '../../common/colors.scss' as colors;
@use '../../common/vars.scss' as vars;

.autopay-modal-backdrop {
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  z-index: 2147483647;
  position: absolute;
  border: none;
  top: 0;
  left: 0;
  display: none;
}

.autopay-modal-container {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
}

.autopay-modal {
  position: relative;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.2);
  -webkit-box-shadow: 0 3px 9px rgb(0 0 0 / 50%);
  box-shadow: 0 3px 9px rgb(0 0 0 / 50%);
  outline: 0;
  max-height: 96vh;
  width: 35%;
  margin: auto;
  margin-bottom: 20vh;
  max-width: 320px;
  z-index: 99999;
  transform: translate3d(0, 0, 0);

  @media (max-width: vars.$tablet) {
    width: 80% !important;
  }
}

.autopay-modal-content-wrapper {
  padding: 1.2em;
}

.autopay-modal-header {
  font-weight: 500;
  font-size: 1.1em;
  margin-bottom: 1em;
}

.autopay-modal-text {
  margin: 1em 0;
  font-weight: 100;
  font-size: 0.87em;
}

.autopay-modal-ctrls {
  margin-bottom: 10px;
  font-weight: 100;
  font-size: 1em;
  text-align: center;

  & > * {
    padding: 10px 16px;
    margin-bottom: 10px;
  }
}

// Flexpay {
:global(.flexpay) {
  .autopay-modal {
    color: colors.$flexpay-title;
  }
}
